// Can be used to transform the hex values from @atlaskit/theme into rgb/rgba
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (hexColor: string, alpha = 1): string => {
	const parsed = hexColor.match(/[a-f0-9]{2}/gi);
	if (!parsed || (parsed && parsed.length !== 3) || hexColor.indexOf('#') < 0) {
		return hexColor;
	}
	const rgb = parsed.map((hex) => parseInt(hex, 16));

	if (alpha < 1 && alpha >= 0) {
		return `rgba(${rgb.concat(alpha).join(',')})`;
	}
	return `rgb(${rgb.join()})`;
};
